// Auto-generated version file - DO NOT EDIT MANUALLY
// Generated on: 2026-10-09T14:15:02.134Z
export const APP_VERSION = "0.1.0.1791555302134";
export const BUILD_DATE = "2026-10-09T14:15:02.135Z";
export const BUILD_TIMESTAMP = 1791555302134;

// Funzione per controllare e gestire aggiornamenti automaticamente
export const handleAppUpdate = async () => {
  const currentVersion = localStorage.getItem('app_version');
  const newVersion = APP_VERSION;
  
  console.log(`🔍 [VERSION] Controllo versione: attuale="${currentVersion}" nuova="${newVersion}"`);
  
  if (currentVersion !== newVersion) {
    console.log(`🔄 [VERSION] App aggiornata automaticamente: ${currentVersion} → ${newVersion}`);
    
    // Pulisci cache automaticamente e silenziosamente
    await clearAllCaches();
    
    // Aggiorna la versione salvata
    localStorage.setItem('app_version', newVersion);
    localStorage.setItem('last_cache_clear', Date.now().toString());
    
    // Ricarica automaticamente la pagina per applicare gli aggiornamenti
    console.log('🔄 [VERSION] Ricaricamento automatico in corso...');
    setTimeout(() => {
      window.location.reload(true);
    }, 500);
    
    return true;
  }
  
  console.log('✅ [VERSION] Versione già aggiornata');
  return false;
};

// Funzione per pulire tutte le cache
export const clearAllCaches = async () => {
  try {
    console.log('🧹 [CACHE] Avvio pulizia cache...');
    
    // 1. Pulisci localStorage mantenendo solo dati essenziali dell'utente
    const essentialKeys = [
      'app_version',
      'user_preferences', 
      'auth_token',
      'user_id',
      'last_cache_clear',
      'firebase_auth_token'
    ];
    
    // Le chiavi kiosk_* (modalità kiosk, ID e nome del dispositivo) vanno
    // SEMPRE preservate: cancellarle trasforma il tablet in un normale browser
    // sulla schermata di login e impedisce le timbrature.
    const storageData = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (essentialKeys.includes(key) || key.startsWith('kiosk_'))) {
        const value = localStorage.getItem(key);
        if (value) storageData[key] = value;
      }
    }
    
    localStorage.clear();
    
    // Ripristina i dati essenziali
    Object.entries(storageData).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
    
    console.log('✅ [CACHE] LocalStorage pulito e ripristinato');
    
    // 2. Pulisci sessionStorage
    sessionStorage.clear();
    console.log('✅ [CACHE] SessionStorage pulito');
    
    // 3. Pulisci Cache API se supportata
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      console.log(`🔍 [CACHE] Trovate ${cacheNames.length} cache da pulire:`, cacheNames);
      await Promise.all(
        cacheNames.map(cacheName => caches.delete(cacheName))
      );
      console.log('✅ [CACHE] Cache API pulita');
    }
    
    // 4. Unregister service worker se presente
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      console.log(`🔍 [CACHE] Trovate ${registrations.length} registrazioni SW da pulire`);
      await Promise.all(
        registrations.map(registration => registration.unregister())
      );
      console.log('✅ [CACHE] Service Worker unregistered');
    }
    
    // 5. Pulisci IndexedDB cache se presente
    if ('indexedDB' in window) {
      try {
        const databases = await indexedDB.databases();
        console.log(`🔍 [CACHE] Trovate ${databases.length} database IndexedDB`);
        await Promise.all(
          databases.map(db => {
            if (db.name && !db.name.includes('firebase')) {
              return new Promise((resolve) => {
                const deleteReq = indexedDB.deleteDatabase(db.name);
                deleteReq.onsuccess = () => resolve();
                deleteReq.onerror = () => resolve(); // Continua anche se fallisce
              });
            }
          })
        );
        console.log('✅ [CACHE] IndexedDB pulito');
      } catch (error) {
        console.warn('⚠️ [CACHE] Errore pulizia IndexedDB:', error);
      }
    }
    
    console.log('🎉 [CACHE] Cache pulite automaticamente');
  } catch (error) {
    console.error('❌ [CACHE] Errore durante la pulizia delle cache:', error);
  }
};

// Funzione per controllare se è necessario un hard refresh
export const checkForceRefresh = () => {
  const lastClearTime = localStorage.getItem('last_cache_clear');
  const currentTime = Date.now();
  
  console.log(`🔍 [REFRESH] Controllo refresh forzato: lastClear=${lastClearTime}, now=${currentTime}`);
  
  // Forza refresh se è passata più di 1 ora dall'ultima pulizia
  if (lastClearTime && (currentTime - parseInt(lastClearTime)) > 3600000) {
    console.log('🔄 [REFRESH] Refresh forzato necessario');
    clearAllCaches();
    localStorage.setItem('last_cache_clear', currentTime.toString());
    return true;
  }
  
  console.log('✅ [REFRESH] Nessun refresh forzato necessario');
  return false;
};
